import { useEffect } from 'react';
import { Spinner } from 'reactstrap';

import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { LuPhone } from 'react-icons/lu';
import { MdOutlineMailOutline } from 'react-icons/md';

import { CREATE_AIRPORT_TRANSFER_BOOKING, GET_PAYMENT_SUMMARY } from '../../../../../../../../store/actions';
import DropIcon from './../../../../../../../../assets/custom/drop.png';
import PickupIcon from './../../../../../../../../assets/custom/pickup.png';

export default function BookingDetailsForm({
  setCurrentActiveForm,
  selectedUser,
  flightNumber,
  locationDetails,
  passengerDetails,
  bookingsDetails,
  additionalDirectionData,
  selectedDate,
  selectedTime,
  setIsShowAddressModal,
  isAddresSaved,
  benefitItemData,
}) {
  const dispatch = useDispatch();

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { paymentSummaryDetails, paymentSummaryLoading } = useSelector((state: any) => ({
    paymentSummaryDetails: state?.GetPaymentSummary?.data,
    paymentSummaryLoading: state?.GetPaymentSummary?.loading,
  }));

  const { createBookingLoading } = useSelector((state: any) => ({
    createBookingLoading: state?.CreateAirportTransferBooking?.loading,
  }));

  const { historyData, historyDataLoading } = useSelector((state: any) => ({
    historyData: state?.GetClientHistoryList?.data,
    historyDataLoading: state?.GetClientHistoryList?.loading,
  }));

  console.log('benefitItemDatabenefitItemData', benefitItemData);

  useEffect(() => {
    dispatch({
      type: GET_PAYMENT_SUMMARY,
      payload: {
        urlParams: {
          numberOfBabySeats: `${passengerDetails?.number_of_baby_seats ?? 0}`,
          numberOfInfantsSeats: `${passengerDetails?.number_of_infants ?? 0}`,
          isInterEmirates: `${locationDetails?.inter_emirates_allowed ? 1 : 0}`,
          airportId: `${locationDetails?.airport_id}`,
          serviceType: `${locationDetails?.service_type}`,
          zoneId: `${locationDetails?.zone_id}`,
          bookingVersion: 'AIRPORT_TRANSFER_V2',
          serviceId: `${locationDetails?.service_name}`,
          configId: `${bookingsDetails?.benefitConfigId}`,
        },
      },
    });
  }, []);

  const createBooking = () => {
    const user = JSON.parse(localStorage.getItem('authUser'))?.data;

    const payload = {
      process: 'initiate-booking',
      numberOfPassengers: `${passengerDetails?.number_of_passengers}`,
      numberOfBabySeats: `${passengerDetails?.number_of_baby_seats}`,
      numberOfLuggages: `${passengerDetails?.number_of_luggages}`,
      numberOfInfants: `${passengerDetails?.number_of_infants}`,

      bookingForSomeoneElse: 0,
      serviceType: {
        type: locationDetails?.service_type,
      },
      pickupLocation: {
        ...(locationDetails?.service_type === `Pickup` && {
          airportId: locationDetails?.airport_id,
        }),

        address: `${locationDetails?.from?.address_details?.address ?? ''}`,
        emirates: ``,
        region: `${locationDetails?.from?.address_details?.region ?? ''}`,
        nickName: ``,
        latitude: `${locationDetails?.from?.geometry?.location?.lat ?? ''}`,
        longitude: `${locationDetails?.from?.geometry?.location?.lng ?? ''}`,
        name: `${locationDetails?.from?.address_details?.address ?? ''}`,
        regionId: `${locationDetails?.from?.address_details?.regionId ?? ''}`,
        zipCode: `${locationDetails?.from?.address_details?.post_code ?? ''}`,
        country: `${locationDetails?.from?.address_details?.country ?? ''}`,
        countryId: ``,
        placeId: `${locationDetails?.from?.place_id ?? ''}`,
      },

      dropLocation: {
        ...(locationDetails?.service_type === `Drop` && {
          airportId: locationDetails?.airport_id,
        }),
        address: `${locationDetails?.to?.address_details?.address ?? ''}`,
        emirates: ``,
        region: `${locationDetails?.to?.address_details?.region ?? ''}`,
        nickName: ``,
        latitude: `${locationDetails?.to?.geometry?.location?.lat ?? ''}`,
        longitude: `${locationDetails?.to?.geometry?.location?.lng ?? ''}`,
        name: `${locationDetails?.to?.address_details?.address ?? ''}`,
        regionId: `${locationDetails?.to?.address_details?.regionId ?? ''}`,
        zipCode: `${locationDetails?.to?.address_details?.post_code ?? ''}`,
        country: `${locationDetails?.to?.address_details?.country ?? ''}`,
        countryId: ``,
        placeId: `${locationDetails?.to?.place_id ?? ''}`,
      },

      pickupDate: moment(selectedDate).format('YYYY-MM-DD'),
      pickupTime: moment(selectedTime, ['h:mm A']).format('HH:mm'),
      flightNumber: flightNumber,
      terminalNumber: '',
      terminalName: '',
      ticketPurchaseDate: '',
      ticketPurchaseAmount: {
        value: 0,
        currency: '',
      },
      ticketUrl: '',
      bookingDate: new Date(new Date(selectedDate).toDateString() + ' ' + selectedTime).toISOString(),
      remarks: '',
      interEmirates: locationDetails?.interEmirates ?? false,
      duration: additionalDirectionData?.duration ?? 1,
      distance: additionalDirectionData?.distance ?? 1,
      durationUnit: 'second',
      distanceUnit: 'meter',
      overviewPolyline: additionalDirectionData?.overviewPolyline ?? 'abc',
      travelMode: additionalDirectionData?.travelMode ?? 'Driving',
      payment: {
        isPreAuth: false,
        amount: paymentSummaryDetails?.totalPayable?.value,
        currency: paymentSummaryDetails?.totalPayable?.currency,
      },
      cardType: {
        cardId: '',
      },
      preferredComms: {
        email: user?.email ?? '',
        mobileNumber: user?.phoneNumber ?? '',
        countryCode: user?.countryCode ?? '',
      },
    };

    dispatch({
      type: CREATE_AIRPORT_TRANSFER_BOOKING,
      payload: {
        urlParams: {
          benefitConfigId: `${bookingsDetails?.benefitConfigId}`,
          membershipId: `${bookingsDetails?.membershipId}`,
          serviceId: `${benefitItemData?.objectId}`,
          userId: `${selectedUser?.userId}`,
        },
        data: payload,
      },
    });
  };

  return (
    <>
      <div className="booking-details-scroll-container hide-scrollbar">
        <div className="form-section-booking-details">
          <h4>Review Booking</h4>

          <LocationDetails
            fromMainText={locationDetails?.from?.address_details?.address}
            fromSecondaryText={makeAddress(locationDetails?.from?.address_details)}
            toMainText={locationDetails?.to?.address_details?.address}
            toSecondaryText={makeAddress(locationDetails?.to?.address_details)}
            setIsShowAddressModal={setIsShowAddressModal}
            isAddresSaved={isAddresSaved}
          />
          <PassengerDetails
            name={`${selectedUser?.firstName} ${selectedUser?.lastName}`}
            mobile={`${selectedUser?.countryCode} ${selectedUser?.phoneNumber}`}
            email={selectedUser?.email}
          />
          <CarDetails
            adults={passengerDetails?.number_of_passengers}
            luggages={passengerDetails?.number_of_luggages}
            babySeats={passengerDetails?.number_of_baby_seats}
            infants={passengerDetails?.number_of_infants}
            travelDate={moment(`${moment(selectedDate).format('YYYY-MM-DD')} ${selectedTime}`, 'YYYY-MM-DD h:mm A').format('DD/MM/YYYY, h:mm A')}
          />
          <FlightDetails flightNumber={flightNumber} />

          {/* {paymentSummaryDetails?.totalPayable?.isRefundable && <PaymentDetails paymentSummary={paymentSummaryDetails} />} */}
        </div>
      </div>

      <div className={`stepper-form-footer-btn`}>
        <div
          className="stepper-form-footer-btn-secondary"
          style={{
            pointerEvents: createBookingLoading || historyDataLoading ? 'none' : 'unset',
          }}
          onClick={() => {
            setCurrentActiveForm(3);
          }}
        >
          Previous
        </div>

        <div
          className="stepper-form-footer-btn-primary"
          onClick={() => {
            // alert('Create booking');
            !createBookingLoading && !historyDataLoading && createBooking();
          }}
        >
          {createBookingLoading || historyDataLoading ? (
            <span>
              <Spinner size="sm" />
            </span>
          ) : (
            'Place Your Booking'
          )}
        </div>
      </div>
    </>
  );
}

function LocationDetails({
  fromMainText,
  fromSecondaryText,
  toMainText,
  toSecondaryText,
  setIsShowAddressModal,
  isAddresSaved,
}: {
  fromMainText: string;
  fromSecondaryText: string;
  toMainText: string;
  toSecondaryText: string;
  setIsShowAddressModal: (value: boolean) => void;
  isAddresSaved: boolean;
}) {
  return (
    <div className="location-details-wrapper">
      <label>Location Details</label>

      <div className="location-details-container">
        <div className="location-details-left">
          <div className="pickup-location-icon">
            <img src={PickupIcon} alt="" className="pickup" />
          </div>
          <div className="drop-location-icon">
            <img src={DropIcon} alt="" className="drop" />
          </div>
          <div className="dashed-separator"></div>
        </div>

        <div className="location-details-right">
          <div className="pickup-location">
            <div className="location-main-heading">{fromMainText}</div>
            <div className="location-secondary-text">{fromSecondaryText}</div>
          </div>

          <div className="drop-location">
            <div className="location-main-heading">{toMainText}</div>
            <div className="location-secondary-text">{toSecondaryText}</div>
          </div>
        </div>

        {!isAddresSaved && (
          <div className="location-details-right">
            <div
              className="save-address-link"
              onClick={() => {
                setIsShowAddressModal(true);
              }}
            >
              Save address
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function PassengerDetails({ name, email, mobile }: { name: string; email: string; mobile: string }) {
  return (
    <div className="passenger-details-wrapper">
      <label>Passenger Details</label>

      <div className="passenger-details">
        <p className="passenger-name">{name}</p>

        <div className="passenger-core-details">
          <div className="core-details">
            <div className="icon">
              <MdOutlineMailOutline />
            </div>
            <div className="details">{email}</div>
          </div>

          <div className="core-details">
            <div className="icon">
              <LuPhone />
            </div>
            <div className="details">{mobile}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function CarDetails({ travelDate, adults, luggages, babySeats, infants }: any) {
  return (
    <div className="car-details-wrapper">
      <label>Car Details</label>

      <div className="core-details-related">
        <div className="core-details-row">
          <div className="core-details-heading">Travel Date & Time</div>
          <div className="core-details-value">{travelDate}</div>
        </div>

        <div className="core-details-row">
          <div className="core-details-heading">Adults(s)</div>
          <div className="core-details-value">{adults}</div>
        </div>

        <div className="core-details-row">
          <div className="core-details-heading">Child Seat(s)</div>
          <div className="core-details-value">{babySeats}</div>
        </div>

        <div className="core-details-row">
          <div className="core-details-heading">Infants(s)</div>
          <div className="core-details-value">{infants}</div>
        </div>

        <div className="core-details-row">
          <div className="core-details-heading">Luggage(s)</div>
          <div className="core-details-value">{luggages}</div>
        </div>
      </div>
    </div>
  );
}

function FlightDetails(flightNumber: { flightNumber: any }) {
  console.log('hellllooo', flightNumber);
  return (
    <div className="flight-details-wrapper">
      <label>Flight Details</label>

      <div className="core-details-related">
        <div className="core-details-row">
          <div className="core-details-heading">Flight Number</div>
          <div className="core-details-value">{flightNumber?.flightNumber}</div>
        </div>
      </div>
    </div>
  );
}

function PaymentDetails({ paymentSummary }) {
  return (
    <div className="payment-details-wrapper">
      <label>Payment Details</label>

      <div className="core-details-related">
        <div className="core-details-row">
          <div className="core-details-heading">Booking Fee</div>
          <div className="core-details-value">
            {paymentSummary?.bookingFee?.currency} {(paymentSummary?.bookingFee?.value ?? 0).toFixed(2)}
          </div>
        </div>

        {paymentSummary?.fees
          ?.filter(fee => fee.category === 1)
          ?.map(item => {
            if (item?.value) {
              return (
                <div className="core-details-row">
                  <div className="core-details-heading">{item?.name}</div>
                  <div className="core-details-value">
                    {paymentSummary?.totalPayable?.currency} {(item?.value).toFixed(2)}
                  </div>
                </div>
              );
            } else return <></>;
          })}

        {paymentSummary?.taxes?.map(item => (
          <div className="core-details-row">
            <div className="core-details-heading">{`VAT & Taxes(${item?.value}%)`}</div>
            <div className="core-details-value">
              {paymentSummary?.totalPayable?.currency} {(item?.amount ?? 0).toFixed(2)}
            </div>
          </div>
        ))}

        {paymentSummary?.discounts?.map(item => (
          <div className="core-details-row">
            <div className="core-details-heading" style={{ color: '#01ab72' }}>
              {' '}
              Discount({item?.value}%)
            </div>
            <div className="core-details-value" style={{ color: '#01ab72' }}>
              {paymentSummary?.totalPayable?.currency} {(item?.amount ?? 0).toFixed(2)}
            </div>
          </div>
        ))}

        {/* <div className="core-details-row">
          <div className="core-details-heading">Vehicle Upgrade Price</div>
          <div className="core-details-value">AI883</div>
        </div>

        <div className="core-details-row">
          <div className="core-details-heading">Discount</div>
          <div className="core-details-value">AI883</div>
        </div> */}
      </div>

      <div className="horizontal-separator"></div>

      <div className="saving-container">
        <div className="total-saving">
          Saving {paymentSummary?.totalPayable?.currency} {paymentSummary?.bookingDiscount?.value?.toFixed(2)}
        </div>
      </div>

      <div className="core-details-related">
        <div className="core-details-row">
          <div className="core-details-heading">Total</div>
          <div className="core-details-value">
            {paymentSummary?.totalPayable?.currency} {paymentSummary?.totalPayable?.value?.toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  );
}

const makeAddress = (address: any) => [address?.region, address?.country].filter(Boolean).join(', ');
